import { lazy } from "react";

export const routes = {
  getStarted: {
    path: "/get-started",
    element: lazy(() => import("../../pages/GetStarted")),
  },
  login: {
    path: "/login",
    element: lazy(() => import("../../pages/Login")),
  },
  signup: {
    path: "/signup",
    element: lazy(() => import("../../pages/SignUp")),
  },
  pinForm: {
    path: "/pin-form",
    element: lazy(() => import("../../pages/PinScreen")),
  },
  SummaryScreen: {
    path: "/summary",
    element: lazy(() => import("../../pages/SummaryScreen")),
  },
  selfSignup: {
    path: "/self-signup",
    element: lazy(() => import("../../pages/SelfSignup")),
  },
  // ⛔️ADD MORE ROUTE ABOVE THIS LINE⛔️
  residentElementStar: {
    path: "*",
    element: lazy(() => import("./redirectElement")),
  },
  termsOfUse: {
    path: "/terms-of-use",
    element: lazy(() => import("../../pages/TermsOfUse")),
  },
  privacyPolicy: {
    path: "/privacy-policy",
    element: lazy(() => import("../../pages/PrivacyPolicy")),
  },
} as const;
